import axios from 'axios'

let uploadPost = axios.create({
  baseUrl: process.env.VUE_APP_API,
  timeout: 10000,
  headers: {
    'content-type': 'multipart/form-data'
  }
})

export default uploadPost
// const formData = new FormData();
//
// // 上送的其他字段
// formData.append('key', 'value')
// // 上传的文件，
// let file = document.querySelector('input[type="file"]')[0].value
// formData.append('myfile', file, file.name)
//
// uploadPost.post('xx.do', formData)
//   .then((res) => {
//
//   })
//   .catch((err) => {
//
//   })
